import classNames from 'classnames'

import whiteLogo from '../../../img/ethos-logo-white.svg'
import rebrandedCheckmark from '../../../img/rebrabded-checkmark-icon.svg'
import rebrandedGrayIcon from '../../../img/rebranded-gray-icon.svg'
import { ComparisonChartYesNoModuleData } from '../ComparisonChartYesNo'
import styles from './Rebranded.module.scss'

interface RebrandedProps {
  moduleData: ComparisonChartYesNoModuleData
}

export const Rebranded = ({ moduleData }: RebrandedProps) => {
  const { groups, title2 } = moduleData

  const renderCheckMark = (yesNo: string) => {
    if (yesNo === 'yes') {
      return <img src={rebrandedCheckmark.src} alt="Check Mark" />
    }
    return <img src={rebrandedGrayIcon.src} alt="Gray Icon" />
  }

  return (
    <div className={styles.chart}>
      <div className={styles.row}>
        <div className={styles.column}>&nbsp;</div>
        <div className={classNames(styles.column, styles.logoColumn)}>
          <img src={whiteLogo.src} alt="Ethos Logo" />
        </div>
        <div className={styles.column}>{title2}</div>
      </div>
      {groups.map((group, index) => (
        <div className={styles.row} key={index}>
          <div className={styles.column}>{group.heading}</div>
          <div className={styles.column}>{renderCheckMark(group.yesNo1)}</div>
          <div className={styles.column}>{renderCheckMark(group.yesNo2)}</div>
        </div>
      ))}
    </div>
  )
}
